import React, { useContext } from "react";
import { ThemeContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";
import { translateSymptom as translateSymptomName } from "../i18n/translateData";

import theme from "../index.scss";

import ReactECharts from 'echarts-for-react';
import { dropRight } from "lodash";

const MedicalBarChart = ({ data, userName, splitView }) => {
    const { t } = useTranslation();
    const { dark } = useContext(ThemeContext);
    const result = [];
    const map = new Map();
    const medicalData = data?.filter(obj => obj.symptom_id !== 53)
    medicalData.forEach(item => {
        if (!map.has(item.factor)) {
            map.set(item.factor, { name: item.factor, value: 0, count: 0 });
        }
        const factor = map.get(item.factor);
        factor.value += item.severity;
        factor.count++;
    });
    map.forEach((value, key) => {
        value.value = (value.value / value.count).toFixed(1);
        result.push(value);
    });
    const sorted = result.sort((a, b) => b.value - a.value);
    const top5 = sorted.slice(0, 5);
    const allZeros = top5.every(item => item.value === 0);

    // Display only — chart data keeps the English factor names
    const translateSymptom = (name) => translateSymptomName(t, name);

    const option = {
        title: {
            text: t("dashboard.topSymptoms"),
            left: 'center',
            textStyle: {
                fontSize: '1.2rem',
                color: dark ? theme.darkModeText : theme.black,
            },
            subtext: allZeros ? t("dashboard.noTrackingData.0") : `${splitView ? `(${userName})` : ""}`,
            subtextStyle: {
                fontSize: '1.3rem',
                color: dark ? theme.darkModeText : theme.primary,
            },
        },
        tooltip: {
            trigger: 'item',
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 16,
                color: dark ? theme.darkModeText : theme.black,
            },
        },
        grid: {
            left: '5%',
            containLabel: true
        },
        yAxis: {
            type: 'category',
            axisLabel: {
                fontSize: 16,
                color: dark ? theme.darkModeText : theme.black,
                formatter: (value) => value.length > 10 ? `${value.slice(0, 10)}...` : value,
            },
            data: top5.map(item => translateSymptom(item.name)).reverse()
        },
        series: [
            {
                data: top5.map(item => item.value).reverse(),
                type: 'bar'
            }
        ]
    };
    return (
        <ReactECharts option={option} style={{ minHeight: "25vh" }} />
    )
}

export default MedicalBarChart;